import { Content, Toolbar } from '@rematter/ui-web';

import { FinanceRootLayout } from '../_layouts/FinanceRootLayout';

import { OverviewAgingChart } from './OverviewAgingChart';
import { OverviewFinancialAccounts } from './OverviewFinancialAccounts';
import { OverviewKpiCards } from './OverviewKpiCards';
import { OverviewRecentBills } from './OverviewRecentBills';
import { OverviewRecentInvoices } from './OverviewRecentInvoices';

import { useTranslations } from '@/finance/i18n/useTranslations';

export const FinanceOverview = () => {
  const t = useTranslations();

  return (
    <FinanceRootLayout className="@FinanceOverview">
      <Toolbar className="flex flex-col items-start" orientation="vertical">
        <h1 className="text-2xl font-semibold">{t.overview.title}</h1>
        <p className="text-sm text-neutral">{t.overview.subtitle}</p>
      </Toolbar>

      <Content className="flex-none grow overflow-auto">
        <div className="flex flex-col gap-6 p-6">
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
            <OverviewKpiCards />
          </div>
          <div className="grid gap-6 lg:grid-cols-2">
            <OverviewFinancialAccounts />
            <OverviewAgingChart />
          </div>
          <div className="grid gap-6 lg:grid-cols-2">
            <OverviewRecentBills />
            <OverviewRecentInvoices />
          </div>
        </div>
      </Content>
    </FinanceRootLayout>
  );
};
